import React,{useEffect, useState} from 'react';
import { Modal,Form, Button } from 'react-bootstrap';

function DateOfVisit (props){
    const [disabled,setDisabled] = React.useState(true)
    const [value,setValue] = useState(null)

    const onChange = async (event) =>{
       await setValue(event.target.value)
        setDisabled(false)
    }
    const handleHide = ()=>{
        setDisabled(true)
        props.handleDatePopup("hide")
    }
    const handlesubmit = () =>{
        props.onChange(value)
        props.handleDatePopup("hide")
    }
    // React.useEffect(()=>{
    // })
    useEffect(()=>{
        // if(Object.keys(props.data).length>0){
        //     setValue(props.data.date)
        // }
        // if(value!=null){
        //     props.onChange(value)
        // }
    })
    return(
        <Modal show={props.show} onHide={handleHide}>
            <Modal.Header closeButton>Date of Visit</Modal.Header>
            <Modal.Body>

             
                <Form>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Please select date of visit</Form.Label>
                        <Form.Control type="date" name={"date"} value={value} onChange={onChange} />
                    </Form.Group>
                </Form>
                
            </Modal.Body>
            <Modal.Footer>
                <Button variant='success'                     disabled={disabled || props.disableSubmit}  // 🛑 disable if clicked or still empty
         onClick={handlesubmit}> OK </Button>
            </Modal.Footer>
        </Modal>
    )


}
DateOfVisit.defaultProps = {
    show:false
}

export default DateOfVisit;